import type { StateContext } from '@ngxs/store';
import { produce } from 'immer';
import type { MultiViewStateModel } from '../MultiViewStateModel';

export function enableLoading(ctx: StateContext<MultiViewStateModel>, current_view_index: number, id: string) {
  ctx.setState(
    produce(ctx.getState(), (draft) => {
      if (!draft.views[current_view_index].isLoading.includes(id)) {
        draft.views[current_view_index].isLoading.push(id);
      }
    })
  );
}

export function disableLoading(ctx: StateContext<MultiViewStateModel>, current_view_index: number, id: string) {
  ctx.setState(
    produce(ctx.getState(), (draft) => {
      draft.views[current_view_index].isLoading = [...draft.views[current_view_index].isLoading.filter((fid) => fid !== id)];
    })
  );
}
